<!--
  Copyright 2023 The Ground Authors.

  Licensed under the Apache License, Version 2.0 (the "License");
  you may not use this file except in compliance with the License.
  You may obtain a copy of the License at

      https://www.apache.org/licenses/LICENSE-2.0

  Unless required by applicable law or agreed to in writing, software
  distributed under the License is distributed on an "AS IS" BASIS,
  WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
  See the License for the specific language governing permissions and
  limitations under the License.
-->

<div
  *ngIf="surveyOwnerEmail"
  class="share-list-container"
>
  <mat-list>
    <mat-list-item>
      <div class="survey-user-list-item">
        <div class="user-icon">
          {{surveyOwnerEmail.charAt(0).toUpperCase()}}
        </div>

        <div>{{surveyOwnerEmail}}</div>

        <div class="survey-owner-label" i18n="@@app.labels.roles.owner">Owner</div>
      </div>
    </mat-list-item>

    <ng-container *ngFor="let entry of acl; let i = index;">
      <mat-list-item *ngIf="surveyOwnerEmail !== entry.email;">
        <div class="survey-user-list-item">
          <div class="user-icon">
            {{entry.email.charAt(0).toUpperCase()}}
          </div>

          <div>{{entry.email}}</div>

          <mat-select
            class="role-select"
            [(value)]="entry.role"
            [hideSingleSelectionIndicator]="true"
            (selectionChange)="onRoleChange($event, i)"
          >
            <mat-option *ngFor="let option of roleOptions" [value]="option.value">
              {{ option.label }}
            </mat-option>

            <mat-divider></mat-divider>

            <mat-option value="-1" class="remove-option" i18n="@@app.labels.remove">Remove</mat-option>
          </mat-select>
        </div>
      </mat-list-item>
    </ng-container>
  </mat-list>
</div>
